module.exports = __webpack_public_path__ + "img/pca_motion_mag2.e05dcc57.gif";